module.exports = __webpack_public_path__ + "static/img_development-main-ddf2c96800df866d1519be962a5f2a29.jpg";